import { useEffect, useState } from "react"
import { BiRefresh } from "react-icons/bi"
import { getCyphersAdmin, PATH_ADMIN_CYPHERS_PDF, PATH_ADMIN_WEBSYSTEM } from "../../api"
import { getAdminAlert, postAdminAlert } from "../../api/admin/adminAlert"
import { FileUpload, Heading, Input, Loading, Section, Select } from "../../components"
import { useAction, useAppState } from "../../hooks"
import { EInfoMessageType, TCypher, TSelect } from "../../types"
import { ETextInputType, FILE_TYPE } from "../../utils"

export const Admin = () => {
    const [loading, setLoading] = useState(false)
    const [selectedCypher, setSelectedCypher] = useState<TSelect<number> | undefined>()
    const [cyphersSelect, setCyphersSelect] = useState<TSelect<number>[]>([])
    const [cyphers, setCyphers] = useState<TCypher[]>([])
    const [adminAlert, setAdminAlert] = useState("")
    const { setInfoMessageAction } = useAction()
    const { state } = useAppState()


    useEffect(() => {
        refresh()
    }, [])

    useEffect(() => {
        setSelectedCypher(cyphersSelect[0])
    }, [cyphersSelect])

    const refresh = () => {
        setLoading(true)
        getAdminAlert({ token: state?.token! }).then(
            res => {
                if (res.alert) {
                    setAdminAlert(res.alert)
                }
            } )
        getCyphersAdmin({ token: state!!.token!! }).then(res => {
            if (res.cyphers) {
                setCyphersSelect(
                    res.cyphers.map(
                        c => ({ key: c.Id, label: `${c.Id}-${c.name}` })
                    )
                )
                setCyphers(res.cyphers)
            }
        }).finally(() => setLoading(false))
    }

    const saveAdminAlert = () => {
        postAdminAlert({
            token: state?.token!,
            alert: adminAlert
        }).then(res => {
            if (res.errorMessage) {
                setInfoMessageAction({ type: EInfoMessageType.ERROR, message: res.errorMessage, timeout: 15 });
            } else {
                setInfoMessageAction({ type: EInfoMessageType.SUCCESS, message: "Upozornění do websystému bylo aktualizováno.", timeout: 15 });
            }
        })
    }

    if (loading) {
        return <Loading />
    }

    return (
        <>
            <Heading headline='Administrace hry' weight={1} />

            <Section>
                <Heading headline='Websystém' weight={2} />
                <div className='refresh'>
                    <BiRefresh onClick={refresh} size={25} />
                </div>
                <FileUpload setLoading={setLoading} fileType={FILE_TYPE.XML} path={PATH_ADMIN_WEBSYSTEM} uploadParams={{}} />

                <Heading headline='PDF k šifrám' weight={2} />
                <Select label='Šifra:' selectedValue={selectedCypher} setSelectedValue={setSelectedCypher} values={cyphersSelect } />
                <FileUpload setLoading={setLoading} fileType={FILE_TYPE.PDF} path={PATH_ADMIN_CYPHERS_PDF} uploadParams={{ id: selectedCypher?.key } } />

                <Heading headline='Admin alert' weight={2} />
                <Input label='Text zprávy' value={adminAlert} setValue={e => setAdminAlert(e.target.value)} type={ETextInputType.TEXTAREA } errorMessage="" />
                <button className='button' onClick={saveAdminAlert}> Uložit</button>
            </Section>
        </>
    )
}